import React, { useCallback } from "react";
import ChipButton from "./ChipButton";
import styles from "./ChipGroup.module.scss";

const ChipGroup = ({
  options,
  value,
  onChange,
  multiple = false,
  showAll = false,
  allLabel = "전체",
  label,
  size,
  className,
}) => {
  const isAllSelected = multiple
    ? !value || value.length === 0
    : value == null;

  const isSelected = useCallback(
    (optionValue) => {
      if (multiple) {
        if (!Array.isArray(value)) return false;
        // 숫자/문자열 혼합 비교 대응
        return value.some((v) => String(v) === String(optionValue));
      }
      return String(value) === String(optionValue);
    },
    [value, multiple]
  );

  const handleClick = useCallback(
    (optionValue) => {
      if (multiple) {
        const current = Array.isArray(value) ? value : [];
        const exists = current.some((v) => String(v) === String(optionValue));
        const next = exists
          ? current.filter((v) => String(v) !== String(optionValue))
          : [...current, optionValue];
        // 모든 옵션이 선택되면 전체와 동일 → 빈 배열로 리셋
        if (next.length >= options.length) {
          onChange([]);
        } else {
          onChange(next);
        }
      } else {
        onChange(String(value) === String(optionValue) ? null : optionValue);
      }
    },
    [value, onChange, multiple, options.length]
  );

  const handleAllClick = useCallback(() => {
    onChange(multiple ? [] : null);
  }, [onChange, multiple]);

  return (
    <div className={`${styles.group} ${className || ""}`}>
      {label && <div className={styles.label}>{label}</div>}
      <div className={styles.chips}>
        {showAll && (
          <ChipButton
            label={allLabel}
            selected={isAllSelected}
            onClick={handleAllClick}
            size={size}
          />
        )}
        {options.map((option) => (
          <ChipButton
            key={option.value}
            label={option.label}
            selected={isSelected(option.value)}
            onClick={() => handleClick(option.value)}
            disabled={option.disabled}
            size={size}
          />
        ))}
      </div>
    </div>
  );
};

export default ChipGroup;
